import type { FunctionComponent } from 'react';
import { Row, Col } from 'react-bootstrap';
import Header from '../common/Header';
import MarketingBlurb from '../common/marketing/Blurb';
import MarketingTrustedBy from '../common/marketing/TrustedBy';

/**
 * Auth two-column layout component, with the marketing blurb.
 */
const TwoColLayout: FunctionComponent = ({ children }) => (
  <div className="fossa-auth__layout--two-col">
    <Header />
    <Row className="fossa-auth__layout">
      <Col
        lg={8}
        md={7}
        smHidden
        xsHidden
      >
        <MarketingBlurb />
        <hr />
        <MarketingTrustedBy />
      </Col>
      <Col lg={4} md={5}>
        {children}
      </Col>
    </Row>
  </div>
);

export default TwoColLayout;
